import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const testimonialsSlider = document.getElementById("testimonials-slider");

	if (testimonialsSlider) {
		const testimonialSlider = new Splide(testimonialsSlider, {
			type: "carousel",
			perPage: 1,
			perMove: 1,
			focus: "center",
			rewind: true,
			arrows: false,
			pagination: false,
			autoplay: false,
			classes: {
				// Disable all default classes that might show content
				pagination: "",
				page: "",
				prev: "",
				next: "",
				arrow: "",
				spinner: "",
			},
			// Disable any loading states
			lazyLoad: false,
			preloadPages: 1,
			trimSpace: false,
		}).mount();

		// Custom navigation
		const prevBtn = document.getElementById("testimonials-prev");
		const nextBtn = document.getElementById("testimonials-next");
		//const progressBar = document.getElementById("testimonials-progress-bar");
		const counter = document.getElementById("testimonials-counter");

		if (prevBtn && nextBtn && counter) {
			// Get total slides
			const totalSlides = testimonialSlider.length;

			// Update progress bar and counter
			// function updateProgressBar(index) {
			//   const progress = ((index + 1) / totalSlides) * 100;
			//   progressBar.style.width = `${progress}%`;
			// }

			function updateCounter(index) {
				// Debug: log what's being set
				const newValue = `${index + 1}/${totalSlides}`;
				console.log("Setting counter to:", newValue);
				counter.textContent = newValue;
			}

			// Initialize progress bar and counter
			//updateProgressBar(0);
			updateCounter(0);

			// Navigation events
			prevBtn.addEventListener("click", () => {
				// Disable buttons during transition
				prevBtn.disabled = true;
				nextBtn.disabled = true;

				testimonialSlider.go("<");
			});

			nextBtn.addEventListener("click", () => {
				// Disable buttons during transition
				prevBtn.disabled = true;
				nextBtn.disabled = true;

				testimonialSlider.go(">");
			});

			// Update navigation button states
			function updateNavigationState(index) {
				prevBtn.disabled = index === 0;
				nextBtn.disabled = index === totalSlides - 1;
			}

			// Initialize navigation state
			updateNavigationState(0);

			// Debug: Watch for all Splide events that might affect content
			testimonialSlider.on("move", (newIndex, oldIndex) => {
				console.log("Splide move event:", oldIndex, "->", newIndex);
				console.log(
					"Counter content during move:",
					counter.textContent
				);
			});

			testimonialSlider.on("moving", (newIndex) => {
				console.log("Splide moving event:", newIndex);
				console.log(
					"Counter content during moving:",
					counter.textContent
				);
			});

			// Update everything when slide actually moves
			testimonialSlider.on("moved", (newIndex) => {
				console.log("Splide moved event:", newIndex);
				updateCounter(newIndex);
				updateNavigationState(newIndex);
			});
		}
	}
});
